import { cn } from '@/lib/cn';

const FDA_TEXT =
  'These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.';

// Required on every product page per product_catalog.md §"Tax / compliance notes".
export function FdaDisclaimer({ className }: { className?: string }) {
  return (
    <p className={cn('text-xs leading-relaxed text-night-blue/70', className)}>
      <span className="font-semibold">FDA Disclaimer:</span> {FDA_TEXT}
    </p>
  );
}
